import { gql } from "apollo-angular";

export const CREATE_TEST_SUITE_MUTATION = gql`mutation configuratorCreateTestSuite($TestSuite: TestSuiteInput) {
    configuratorCreateTestSuite(TestSuite: $TestSuite) {
        responseMessages
        returnValue
        success
    }
  }
  `

export const UPDATE_TEST_SUITE_MUTATION = gql`mutation configuratorUpdateTestSuite($TestSuite: TestSuiteInput) {
    configuratorUpdateTestSuite(TestSuite: $TestSuite) {
        responseMessages
        returnValue
        success
    }
  }
  `
  

export const DELETE_TEST_SUITE_MUTATION = gql`mutation configuratorDeleteTestSuite($Uid: String!) {
    configuratorDeleteTestSuite(Uid: $Uid)
  }
  `

export const EXPORT_TEST_SUITE_MUTATION = gql`mutation configuratorExportTestSuite($Uid: String!) {
    configuratorExportTestSuite(Uid: $Uid)
  }
  `
  